import React, { useState } from "react";
import { Plus, X } from "lucide-react";
import { cn } from "@/lib/utils";

interface ScorecardSynopsisCardProps {
  synopsis: string;
  interactive?: boolean;
  compact?: boolean;
}

export function ScorecardSynopsisCard({
  synopsis,
  interactive = true,
  compact = false,
}: ScorecardSynopsisCardProps) {
  const [expanded, setExpanded] = useState(false);

  if (!synopsis?.trim()) return null;

  return (
    <div
      className={cn(
        "rounded-lg border bg-[#141414] transition-colors duration-200",
        compact ? "mb-3" : "mb-6",
        expanded ? "border-gold-button" : "border-[#2a2a2a]"
      )}
    >
      <div className={compact ? "p-3 md:p-3.5" : "p-5 md:p-6"}>
        <p
          className={
            compact
              ? "text-[9px] font-sans font-medium uppercase tracking-[0.2em] text-white/40 mb-1"
              : "text-[10px] font-sans font-medium uppercase tracking-[0.2em] text-white/40 mb-2"
          }
        >
          Synopsis
        </p>
        {expanded && (
          <div
            className={
              compact
                ? "text-xs font-sans text-white/80 leading-snug whitespace-pre-wrap"
                : "text-sm font-sans text-white/80 leading-relaxed whitespace-pre-wrap"
            }
          >
            {synopsis}
          </div>
        )}

        <button
          type="button"
          onClick={interactive ? () => setExpanded((v) => !v) : undefined}
          disabled={!interactive}
          className={cn(
            compact
              ? "mt-3 w-full flex items-center justify-between rounded-full px-3 py-2"
              : "mt-5 w-full flex items-center justify-between rounded-full px-4 py-2.5",
            "text-[10px] font-sans font-medium uppercase tracking-[0.15em] transition-colors",
            "bg-gold-button text-neutral-700",
            interactive ? "hover:bg-gold-light cursor-pointer" : "cursor-default"
          )}
          aria-expanded={expanded}
        >
          <span>{expanded ? "Hide synopsis" : "View synopsis"}</span>
          <span
            className={cn(
              "flex items-center justify-center w-6 h-6 rounded-full",
              "border border-neutral-600/30 text-neutral-700"
            )}
          >
            {expanded ? <X className="w-3 h-3" /> : <Plus className="w-3 h-3" />}
          </span>
        </button>
      </div>
    </div>
  );
}
